import { UseLayoutProps } from './types';

export const useLayoutProps: UseLayoutProps = ({
  lang,
  alternate_languages,
  fallbackUrls,
  isDark,
  ...props
}) => {
  const alternateLanguages = alternate_languages.map(({ document }) => ({
    url: document.url,
    language: document.lang,
  }));

  return {
    currentLanguage: lang,
    alternateLanguages,
    fallbackUrls,
    isDark,
    ...props,
  };
};
